import { MessageService } from './message.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { Page } from './page';
import { Chapter } from './chapter';
//import { PAGES } from './mock-pages';
import { PAGES_DATA } from './pages.data';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./message.service";
var httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
var PageService = /** @class */ (function () {
    //private pagesUrl = 'api/pages';  // URL to web api
    //private http: HttpClient; 
    function PageService(http, messageService) {
        this.http = http;
        this.messageService = messageService;
    }
    /** GET pages from the server */
    PageService.prototype.getPages1 = function () {
        // return this.http.get<Page[]>(this.pagesUrl)
        // .pipe(
        // tap(pages => this.log(`fetched pages`)),
        // catchError(this.handleError('getPages', []))
        // );
        return null;
    };
    PageService.prototype.getPages = function (chapter_idx) {
        var chapter_data = PAGES_DATA[chapter_idx];
        var pages = (chapter_data != null) ? chapter_data.data.map(function (x) { return new Page(x); }) : [];
        return of(pages);
    };
    PageService.prototype.getChapters = function () {
        var chapter_titles = PAGES_DATA.map(function (x) { return (x.chapter); });
        //console.log(chapter_titles);
        var chapters = chapter_titles.map(function (el, idx) {
            var chapter_data = PAGES_DATA[idx];
            //console.log(chapter_data);
            var chp = new Chapter();
            var pages = chapter_data != null ? chapter_data.data.map(function (x) { return new Page(x); }) : [];
            chp.subject = el;
            chp.pages = pages;
            chp.index = chapter_data.index;
            //console.log(chp);
            return chp;
        });
        return of(chapters);
    };
    PageService.prototype.getPageData = function (uid) {
        //var base_url = 'http://www.jsd.or.kr/?m=bbs&mod=json_article_view&uid=';
        var base_url = '//www.jsd.or.kr/pages/docs/cscs/get_markdown.php?uid=';
        var url = base_url + uid;
        //$g['url_root']."/?r=".$r."&amp;m=".$m."&amp;bid=".$R['bbsid']."&amp;uid=".$R['uid'];
        return this.http.get(url);
    };
    PageService.prototype.getChapterForPage = function (uid) {
        var chapter = 0;
        var pages = PAGES_DATA.map(function (x) { return (x.data); });
        pages.map(function (page, ch_idx) {
            if (page['uid'] == uid) {
                chapter = ch_idx + 1;
            }
        });
        return chapter;
    };
    PageService.prototype.getTitleForUid = function (uid) {
        var pages = PAGES_DATA.map(function (x) { return (x.data); });
        //let flatted_pages = [].concat(...pages);
        var flatted_pages = pages.reduce(function (acc, val) { return acc.concat(val); }, []);
        var index = flatted_pages.findIndex(function (x) { return x.uid == parseInt(uid); });
        var page = flatted_pages[index];
        return page.subject;
    };
    PageService.prototype.getPrevNextPageUid = function (uid) {
        var pages = PAGES_DATA.map(function (x) { return (x.data); });
        //let flatted_pages = [].concat(...pages);
        var flatted_pages = pages.reduce(function (acc, val) { return acc.concat(val); }, []);
        var _prev = null, _next = null;
        var index = flatted_pages.findIndex(function (x) { return x.uid == parseInt(uid); });
        if (index >= 0) {
            _prev = (function (arr, i) {
                i = i + 1;
                i = i % arr.length;
                return arr[i];
            })(flatted_pages, index);
            _next = (function (arr, i) {
                if (i === 0) {
                    i = arr.length;
                }
                i = i - 1;
                return arr[i];
            })(flatted_pages, index);
        }
        var _out = { prev: _prev, next: _next };
        //console.log(_out);
        return _out;
    };
    PageService.prototype.getPrevPageUid = function (uid) {
        var prevnext = this.getPrevNextPageUid(uid);
        return prevnext.prev != null ? prevnext.prev.uid.toString() : 0;
    };
    PageService.prototype.getNextPageUid = function (uid) {
        var prevnext = this.getPrevNextPageUid(uid);
        return prevnext.next != null ? prevnext.next.uid.toString() : 0;
    };
    PageService.prototype.handleError = function (operation, result) {
        var _this = this;
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            _this.log(operation + " failed: " + error.message);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    /** Log a HeroService message with the MessageService */
    PageService.prototype.log = function (message) {
        this.messageService.add('PageService: ' + message);
    };
    PageService.ngInjectableDef = i0.defineInjectable({ factory: function PageService_Factory() { return new PageService(i0.inject(i1.HttpClient), i0.inject(i2.MessageService)); }, token: PageService, providedIn: "root" });
    return PageService;
}());
export { PageService };
